export function initMenu() {
  const trigger = document.querySelector('.topbar__menu');
  const menu = document.querySelector('.menu');
  if (!trigger || !menu) return;

  let open = false;

  function set(next) {
    open = next;
    menu.classList.toggle('is-open', open);
    menu.setAttribute('aria-hidden', String(!open));
    trigger.setAttribute('aria-expanded', String(open));
    trigger.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
    document.body.style.overflow = open ? 'hidden' : '';
  }

  trigger.addEventListener('click', () => set(!open));
  menu.querySelectorAll('a').forEach((a) =>
    a.addEventListener('click', () => set(false))
  );
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && open) set(false);
  });
}
